<template>
  <div class="positive">
    <section v-if="isInitWithoutPayment">
      <h2 class="normal" v-html="$t('result.positive.initWithoutPayment.header')"></h2>
      <p
        v-html="$t('result.positive.initWithoutPayment.description', {shopName: transaction.receiverNameForFront})"></p>
      <partner-return-btn v-if="visibilityOptions && visibilityOptions.showReturnToShopButton"
                          :return-url="returnUrl"
                          :return-text="$t('result.positive.initWithoutPayment.button')"/>
    </section>
    <section v-if="isInitWithPayment">
      <h2 class="normal" v-html="$t('result.positive.initWithPayment.header')"></h2>
      <p v-html="$t('result.positive.initWithPayment.description')"></p>
      <partner-return-btn v-if="visibilityOptions && visibilityOptions.showReturnToShopButton"
                          :return-url="returnUrl"
                          :return-text="$t('result.positive.initWithPayment.button')"/>
    </section>
    <section v-if="isInitWithRefund">
      <h2 class="normal" v-html="$t('result.positive.initWithRefund.header')"></h2>
      <p v-html="$t('result.positive.initWithRefund.description1')"></p>
      <p v-html="$t('result.positive.initWithRefund.description2', {amount: transaction.payAmount, currency: transaction.payAmountCurrency})"></p>
      <partner-return-btn v-if="visibilityOptions && visibilityOptions.showReturnToShopButton"
                          :return-url="returnUrl"
                          :return-text="$t('result.positive.initWithRefund.button')"/>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BLIK_RECURRING_ACTION } from '@/base/const/blik.const'
import PartnerReturnBtn from '@/base/components/Confirmation/PartnerReturnBtn.vue'

export default {
  name: 'ResultPositive',
  components: { PartnerReturnBtn },
  computed: {
    ...mapState({
      transaction: state => state.result.data?.transaction,
      visibilityOptions: state => state.result.data?.visibilityOptions,
      returnUrl: state => state.result.data?.returnUrl
    }),
    isInitWithoutPayment: function () {
      return this.transaction && this.transaction.recurringData.recurringAction === BLIK_RECURRING_ACTION.initWithoutPayment
    },
    isInitWithPayment: function () {
      return this.transaction && this.transaction.recurringData.recurringAction === BLIK_RECURRING_ACTION.initWithPayment
    },
    isInitWithRefund: function () {
      return this.transaction && this.transaction.recurringData.recurringAction === BLIK_RECURRING_ACTION.initWithRefund
    }
  }
}
</script>
